import Vue from "vue";
import Component from "vue-class-component";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "BremboStore" })
export default class BremboStore extends Vue {
    public localizer: any = Localizer;
    public isVisible: boolean = false;
    public isReady: boolean = false;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        let cookie = CookieHelper.getCookie("bsb");
        let vm = this;
        if (!cookie && CookieHelper.isCookiePolicy()) {
            this.isVisible = true;

            setTimeout(() => {
                vm.isReady = true;
            }, 1000);
        }
    }

    public close() {
        CookieHelper.setCookie("bsb", "bsb", 30);
        this.isVisible = false;
    }

    public openLink() {
        let vm = this;
        CookieHelper.setCookie("bsb", "bsb", 30);
        this.isReady = false;
        window.open("https://www.brembostore.com?utm_source=bremboparts&utm_medium=referral&utm_campaign=link_banner", "_blank", "noopener,noreferrer");
        GTagHelper.sendEvent("click", "BremboStore.com", "banner");
    }
};